import React from 'react';
import {useSelector} from "react-redux";
import {IAppState} from "../interface/redux/IAppState";
import {Link} from "react-router-dom";
import {miniSvg} from "../page/Home";


const Locale: React.FC<{ code: string }> = ({code}) => {

    const language = useSelector((state: IAppState) => state.setup.language);
    return <>{DICTIONARY[code]?.[language]}

    </>;
};
export default Locale;


const DICTIONARY: { [prop: string]: { sk: string | React.JSX.Element, en: string | React.JSX.Element } } = {
    'menu.home': {
        sk: 'Domov',
        en: 'Home',
    },
    'menu.about': {
        sk: 'O nás',
        en: 'About us',
    },
    'menu.contact': {
        sk: 'Kontakt',
        en: 'Contact',
    },
    'menu.service': {
        sk: 'Služby',
        en: 'Services',
    },
    'footer.contact': {
        sk: 'kontakt',
        en: 'contact',
    },
    'footer.gdpr': {
        sk: 'Zásady ochrany osobných údajov',
        en: 'Personal data protection policy',
    },
    'home.title': {
        sk: 'Práve sa nachádzate na správnom mieste ak chcete posunúť váš biznis na novú úroveň a zabezpečiť vašej firme finančnú starostlivosť, akú si zaslúži. Vyberte si z ponuky našich služieb cestu k úspechu.',
        en: 'You are in the right place if you want to take your business to the next level and provide your company with the financial care it deserves. Choose from our range of services and find your way to success.',
    },
    'home.management': {
        sk: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Finančný
                Manažment </h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Dosahujte svoje ciele
                a&nbsp;efektívne využívajte
                prostriedky vo vašom
                podnikaní. Nastavíme vám
                procesy, nástroje a správu financií
                individuálne pre potreby vášho
                podnikania.</p></div>
        </>,
        en: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Financial management</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Achieve your goals and use effectively funds in your
                business. We will set it up for you processes, tools and financial management individually for your
                needs business.</p></div>
        </>,
    },
    'home.controlling': {
        sk: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Finančný Kontroling</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Buďte vždy o krok vpred a reagujte promptne na zmeny.
                Pravidelným analyzovaním vašich finančných transakcií identifikujeme trendy, ktoré nám umožňujú
                predikovať príležitosti a riziká.</p></div>
        </>,
        en: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Financial Controlling</h3>
            </div>
            <div><p className="text-gray-700 dark:text-gray-100">Always be one step ahead and respond promptly to
                changes. By regularly analyzing your financial transactions we identify trends that us make it possible
                to predict opportunities and risks.</p></div>
        </>,
    },
    'home.reporting': {
        sk: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Reporting</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Rozhodujte sa rýchlejšie a efektívnejšie. Poskytneme
                vám prístup k jasne spracovaným finančným dátam a výkonnostným ukazovateľom, ktoré sú ľahko pochopiteľné
                pre vás aj vašich kolegov.</p></div>
        </>,
        en: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Reporting</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Make decisions faster and more efficient. We will
                provide you access to clearly processed financial and performance data indicators that are easy
                understandable to you and yours colleagues.</p></div>
        </>,
    },
    'home.development': {
        sk: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Business Development</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Objavte nové možnosti pre rast vášho podnikania.
                Spoločne nájdeme spôsoby ako zvýšiť predaje a hodnotu vašej značky na trhu.</p></div>
        </>,
        en: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">Business Development</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Discover new opportunities for growth your business.
                Together we will find ways to increase your sales and value brands on the market.</p></div>
        </>,
    },
    'home.education': {
        sk: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">KERNIS Akadémia</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Získajte nové vedomosti pre lepšie porozumenie firemným
                financiám. Poskytneme odborné vzdelávanie vám a vaším zamestnancom.</p></div>
        </>,
        en: <>
            <div className={'relative'}>{miniSvg}<h3 className="mb-2 text-xl font-bold text-gray-700 dark:text-gray-100">KERNIS Academy</h3></div>
            <div><p className="text-gray-700 dark:text-gray-100">Get new knowledge for better understanding of corporate
                finances. We will provide professional education to you and yours employees.</p></div>
        </>,
    },
    'home.show-more': {
        sk: 'viac info',
        en: 'show more',
    },
    'service.management': {
        sk: <div className="inline text-justify"><h3
            className="mb-2 text-xl font-bold logo-blue-color">Finančný Manažment </h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text className="font-bold"></text>
                <div><b className="font-bold">Dosahujte svoje ciele a efektívne využívajte
                    prostriedky vo vašom podnikaní.</b></div>
                <br/>Ako majiteľ firmy dobre viete, aké náročné môže byť orientovať sa vo
                financiách vašej spoločnosti. Naša služba Finančný manažment je navrhnutá
                špeciálne pre firmy ako tá vaša, s cieľom poskytnúť komplexné riešenia pre
                každodennú finančnú stabilitu a dlhodobý rast.
            </p>
            <div>
                <div>
                    <div
                        className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">Čo
                        vám naša služba ponúka:
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Prvotná
                                            finančná analýza:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Poskytneme
                                            vám jasný obraz o aktuálnom finančnom zdraví
                                            vašej firmy, ktorý je základom pre naše ďalšie
                                            kroky.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Optimalizácia
                                            organizačnej štruktúry a finančných procesov:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Nastavíme
                                            vaše interné procesy tak, aby podporovali
                                            efektívne fungovanie vašej organizácie.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Riadenie
                                            cashflow:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Z
                                            dlhodobého hľadiska zaistíme, že budete mať
                                            dostatok finančných prostriedkov na pokrytie
                                            vašich potrieb a investícií.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Finančný
                                            kontroling:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Pravidelne
                                            monitorujeme vaše finančné transakcie voči
                                            firemnému plánu, vyhodnotíme príčiny a
                                            poskytneme odporúčania, ktoré vám pomôžu sa
                                            kvalifikovane rozhodnúť.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Reporting:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Poskytneme
                                            vám pravidelné prehľady a reporty, ktoré vám a
                                            vašim zamestnancom umožnia mať prehľad o výkone
                                            vašej firmy.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-bold text-gray-700 dark:text-gray-100">Riadenie
                                            rizík:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">Riadením
                                            rizík systematicky pristupujeme k identifikácii,
                                            posudzovaniu a zvládaniu rizík, ktoré môžu
                                            ovplyvniť vaše podnikanie. Cieľom je
                                            minimalizovať negatívne dopady a maximalizovať
                                            príležitosti, ktoré tieto riziká predstavujú.
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
        en: <div className="inline text-justify">
            <h3 className="mb-2 text-xl font-bold logo-blue-color">Financial
                management</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text className="font-bold"></text>
                <div><b className="font-bold">Achieve your goals and use resources effectively in your business.</b>
                </div>
                <br/>As a business owner, you know how difficult it can be to navigate your company's finances. Ours
                the Financial Management service is designed specifically for companies like yours, with the aim of
                providing comprehensive solutions for everyday financial stability and long-term growth.
            </p>
            <div>
                <div>
                    <div className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">What our service
                        offers you:
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Initial
                                            financial analysis:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">The
                                            initial financial analysis will give you an overview of where your
                                            company is, what its „starting“ position is, on the basis of which we
                                            will prepare and prioritize the next course of action.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Optimization of
                                            organizational structure and financial processes.:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">We
                                            will set up your internal processes to support the efficient functioning
                                            of your organization.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Cashflow
                                            management:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">In
                                            the long term, we will ensure that you have enough funds to cover your
                                            needs and investments.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Financial
                                            controlling:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">We
                                            regularly monitor your financial transactions against the company plan,
                                            evaluate the causes and provide recommendations to help you make an
                                            informed decision.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Reporting:
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">We
                                            will provide you with regular overviews and reports that will allow you
                                            and your employees to have an overview of your company's performance.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-bold text-gray-700 dark:text-gray-100">Risk management
                                            :
                                        </text>
                                        <text
                                            className="ml-2 font-light text-gray-700 text-base dark:text-gray-100">With
                                            risk management, we systematically approach the identification,
                                            assessment and management of risks that may affect your business. The
                                            aim is to minimize negative impacts and maximize the opportunities these
                                            risks present.
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
    },
    'service.controlling': {
        sk: <div className="inline text-justify"><h3
            className="mb-2 text-xl font-bold logo-blue-color">Finančný Kontroling</h3><p
            className="text-gray-700 dark:text-gray-100 mb-3"><b
            className="font-bold"> Buďte vždy o krok vpred a reagujte promptne na zmeny.</b><br/><br/>Potrebujete
            sa rýchlo zorientovať v spleti informácií o tom, ako sa napĺňajú vaše finančné
            plány, alebo ktorá časť vašej firmy nepracuje optimálne? V rámci služby Finančný
            kontroling pre vás proaktívne odsledujeme správnosť a oprávnenosť vašich
            finančných transakcii a pripravíme efektívne opatrenia na dosahovanie vašich
            cieľov.</p>
            <div>
                <div>
                    <div
                        className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">
                        <b className="font-bold">Čo vám naša služba ponúka</b>:
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Vecná
                                            a časová analýza finančných transakcií.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Stav
                                            plnenia cieľov - porovnanie reality voči plánu
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Identifikácia
                                            príležitostí a rizík a promptná reakcia
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Aktualizácia
                                            finančného plánu (Forecast) podľa nových
                                            skutočností
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
        en: <div className="inline text-justify"><h3 className="mb-2 text-xl font-bold logo-blue-color">Financial
            Controlling</h3><p className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold"> Always be
            one step ahead and respond promptly to changes.</b><br/><br/>Do you need to quickly navigate the tangle
            of information about how your financial plans are being fulfilled, or which part of your company is not
            working optimally? As part of the Financial controlling service, proactively for you we monitor the
            correctness and legitimacy of your financial transactions and prepare effective measures to achieve your
            goals.</p>
            <div>
                <div>
                    <div className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2"><b
                        className="font-bold">What our service offers you</b>:
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Material and
                                            temporal analysis of financial transactions.
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Status of
                                            meeting goals - comparison of reality against the plan
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Identification
                                            of opportunities and risks and prompt response
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Updating the
                                            financial plan (Forecast) according to new facts
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
    },
    'service.reporting': {
        sk: <div className="inline text-justify"><h3
            className="mb-2 text-xl font-bold logo-blue-color">Reporting</h3><p
            className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold">Rozhodujte
            sa rýchlejšie a efektívnejšie.</b><br/><br/>Vaša firma generuje kvantum nových
            (niekedy nesúrodých) dát, ktoré potrebujete pravidelne a efektívne očistiť,
            prepojiť a zanalyzovať, no neviete ako na to. So službou Reporting vám ponúkame
            naše know- how pri príprave tradičných finančných a výkonnostných správ ako aj
            prehľady ušité na mieru vášmu podnikaniu.</p>
            <div>
                <div>
                    <div
                        className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">Čo
                        vám naša služba ponúka
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">
                                            <b className="font-bold">Spracovanie dát: </b>Prispôsobíme
                                            sa vaším potrebám a veľkosti, či už hľadáte
                                            jednoduché a rýchle riešenie cez tabuľkové
                                            aplikácie (MS Excel, Google Sheets) alebo
                                            sofistikovanejšie spôsoby v podobe Business
                                            Intelligence aplikácií (MS PowerBI, Google
                                            Looker).
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">
                                            <b className="font-bold"> Reporting na
                                                mieru: </b>Spoločne identifikujeme a
                                            nastavíme ukazovatele relevantné pre vaše
                                            podnikanie, ich zobrazovanie (grafy, tabuľky,
                                            diagramy) a frekvenciu, s ktorou vám ich budeme
                                            dodávať.
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
        en: <div className="inline text-justify"><h3 className="mb-2 text-xl font-bold logo-blue-color">Reporting</h3><p
            className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold">Make decisions faster and
            more efficiently.</b><br/><br/>Your company generates a lot of new (sometimes disparate) data that you
            need to regularly and efficiently clean, link and analyze, but you don't know how to do it. With the
            Reporting service, we offer you our know- how to prepare traditional financial and performance reports
            as well as reports tailored to your business.</p>
            <div>
                <div>
                    <div className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">What our service
                        offers you
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100"><b
                                            className="font-bold">Data Processing: </b>We adapt to your needs and
                                            size, whether you are looking for a simple and fast solution through
                                            spreadsheet applications (MS Excel, Google Sheets) or more sophisticated
                                            ways in the form of Business Intelligence applications (MS PowerBI,
                                            Google Looker).
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100"><b
                                            className="font-bold"> Custom reporting: </b>Together we will identify
                                            and set the indicators relevant to your business, their display (graphs,
                                            tables, diagrams) and the frequency with which we will deliver them to
                                            you.
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
    },
    'service.development': {
        sk: <div className="inline text-justify"><h3
            className="mb-2 text-xl font-bold logo-blue-color">Business Development</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3"><b
                className="font-bold"> Objavte nové možnosti pre rast vášho
                podnikania.</b><br/><br/>
                <div>Potrebujete pomôcť nájsť nové trhy, nových zákazníkov, nové produkty
                    alebo nové služby? Hľadáte možnosti nájsť finančné zdroje? S našou
                    Business Development službou radi pomôžeme vašej firme akcelerovať rast,
                    zvýšiť jej konkurencieschopnosť a na konci dňa hodnotu, ktorú generuje
                    pre vás a vašich investorov.
                </div>
            </p>
            <div>
                <div>
                    <div
                        className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">Čo
                        vám naša služba ponúka
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Analýza
                                            trhu a konkurencie
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Príprava
                                            stratégie a business plánu
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Podpora
                                            predaja a marketingu
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline"
                                         viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text
                                            className="font-light text-gray-700 dark:text-gray-100">Hľadanie
                                            spôsobov financovania rastu
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
        en: <div className="inline text-justify"><h3 className="mb-2 text-xl font-bold logo-blue-color">Business
            Development</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold"> Discover new
                possibilities for growing your business.</b><br/><br/>
                <div>Do you need help finding new markets, new customers, new products or new services? Are you
                    looking for ways to find financial resources? We will be happy to help your company with our
                    Business Development service accelerate growth, increase its competitiveness and, at the end of
                    the day, the value it generates for you and your investors.
                </div>
            </p>
            <div>
                <div>
                    <div className="font-bold text-gray-700 text-base dark:text-gray-100 mb-2">What our service
                        offers you
                    </div>
                    <div>
                        <ul className="space-y-4 text-left text-gray-700 dark:text-gray-100 ml-4">
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Market and
                                            competition analysis
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Preparation of
                                            strategy and business plan
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Sales and
                                            marketing support
                                        </text>
                                    </text>
                                </div>
                            </li>
                            <li className="flex items-center space-x-3 rtl:space-x-reverse">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24"
                                         className="w-4 h-4 text-primary-600 dark:text-primary-300 logo-blue-color mr-2">
                                        <path xmlns="http://www.w3.org/2000/svg"
                                              d="M12,19a7,7,0,1,1,7-7A7.008,7.008,0,0,1,12,19Z"></path>
                                    </svg>
                                </div>
                                <div>
                                    <text>
                                        <text className="font-light text-gray-700 dark:text-gray-100">Finding ways
                                            to finance growth
                                        </text>
                                    </text>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>,
    },
    'service.education': {
        sk: <div className="inline text-justify">
            <h3 className="mb-2 text-xl font-bold logo-blue-color">
                <text>KERNIS Akadémia</text>
            </h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold">Získajte
                nové vedomosti pre lepšie porozumenie firemným financiám</b><br/><br/>V
                dnešnom turbulentnom svete, kde technológie neustále vplývajú na pracovné
                prostredie, sa vzdelávanie a získavanie nových zručností stáva rozhodujúcim
                faktorom pre udržanie a prosperitu jednotlivcov i firiem na trhu. Už nestačí
                len držať krok s dobou, ale skôr ju proaktívne ovplyvňovať neustálym
                rozvojom. Investícia do ľudského kapitálu nie je len nákladom, ale
                strategickou výhodou, ktorá prinesie dividendy v podobe inovácií, vyššej
                produktivity a spokojnejšieho pracovného tímu. Investovať do vzdelávania a
                rozvoja vašich zamestnancov je investíciou do budúcnosti vašej
                firmy.<br/><br/>Ponúkame vám naše know-how a to formou individuálnych
                workshopov, mentoringu alebo coachingu.</p>
            <div></div>
        </div>,
        en: <div className="inline text-justify">
            <h3 className="mb-2 text-xl font-bold logo-blue-color">
                <text>KERNIS Academy</text>
            </h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3"><b className="font-bold">Get new knowledge to
                better understand corporate finance</b><br/><br/>In today's turbulent world, where technology constantly
                affects the work environment, education and the acquisition of new skills becomes a decisive factor
                for the retention and prosperity of individuals and companies on the market. It is no longer enough
                to just keep up with the times, but rather to proactively influence it constantly development.
                Investing in human capital is not just a cost, but a strategic advantage that it will bring
                dividends in the form of innovations, higher productivity and a more satisfied work team. Invest in
                education and development of your employees is an investment in the future of your
                company.<br/><br/>We offer you our know-how in the form of individual workshops, mentoring or
                coaching.</p>
        </div>,
    },
    'about.description': {
        sk: <div>Našim cieľov je poskytovať vašej firme profesionálne služby finančného riadenia, aby ste boli vy
            schopný napĺňať svoje vízie a posúvať vaše podnikanie na novú úroveň. To sa samozrejme nestane zo dňa na
            deň. Preto naše služby ponúkame individualizované pre každého klienta zvlášť, podľa jeho potrieb. Budujeme
            dlhodobú spoluprácu a partnerstvo založené na dôvere. Chceme vám skrz vaše finančne dáta ukázať možnosti ako
            byť ešte úspešnejší. Tie spracujeme do podoby, ktorej budete rozumieť hlavne vy (a nielen váš bankár alebo
            účtovník).</div>,
        en: <div>Our goals are to provide your company with professional financial management services so that you are
            able to fulfill your visions and take your business to a new level. Of course, this will not happen
            overnight day. That's why we offer our services individually for each client, according to their needs. We
            build long-term cooperation and partnership based on trust. We want you through your financial data show the
            possibilities of how to be even more successful. We will process them in a form that you (and not only your
            banker or accountant) will understand.</div>,
    },
    'about.hajduk': {
        sk: <div><h3 className="mb-2 text-xl font-bold dark:text-white">Juraj Hajduk</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text
                    className="text-gray-700 dark:text-gray-100 font-bold">Špecializácia:
                </text>
                Finančný manažment
            </p>
            <div>
                <div className="font-bold">Bio:</div>
                Juraj má viac ako 10-ročné skúsenosti v oblasti finančného manažmentu,
                kontrolingu, reportingu, riadenia procesov a tímov. Po absolvovaní
                ekonomického štúdia na Technickej univerzite v Košiciach sa
                postupne vypracoval na pozíciu finančného manažéra v nadnárodnej
                spoločnosti, kde spolupracoval s expertmi na finančné procesy z celého sveta
                a implementoval najnovšie technológie a postupy. Mimo
                finančného manažmentu sa venuje aj manažmentu operatívy a riadenia
                podnikateľských rizík.
                <div><Link className="logo-blue-color" to="/contact ">Kontaktovať
                    ma môžete tu</Link></div>
            </div>
        </div>,
        en:
            <div><h3 className="mb-2 text-xl font-bold dark:text-white">Juraj Hajduk</h3>
                <p className="text-gray-700 dark:text-gray-100 mb-3">
                    <text className="text-gray-700 dark:text-gray-100 font-bold">Specialization:</text>
                    Financial management
                </p>
                <div>
                    <div className="font-bold">Bio:</div>
                    Juraj has more than 10 years of experience in financial management, controlling, reporting, process
                    and team management. After completing economic studies at the Technical University in Košice,
                    he gradually worked his way up to the position of financial manager in a multinational company,
                    where he collaborated with financial process experts from around the world and implemented the
                    latest technologies and procedures. Outside
                    financial management also deals with operational management and business risk management.
                    <div><Link className="logo-blue-color" to="/contact ">You can contact me here</Link></div>
                </div>
            </div>
        ,
    },
    'about.marton': {
        sk: <div><h3 className="mb-2 text-xl font-bold dark:text-white">Tomáš Marton</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text
                    className="text-gray-700 dark:text-gray-100 font-bold">Špecializácia:
                </text>
                Finančný kontroling
            </p>
            <div>
                <div className="font-bold">Bio:</div>
                Tomáš je finančným kontrolórom Kernis tímu. Už počas štúdia započal svoju
                kariéru ako procesný špecialista merania výkonu vnútro-firemných procesov v
                košickej pobočke medzinárodnej spoločnosti, kde sa
                neskôr vypracoval na celofiremného finančného kontrolóra. Aktuálne pôsobí v
                Košiciach ako kontrolér a dátový analytik so špecializáciou na analyzovanie
                trendov a identifikovanie anomálií v oblasti cenotvorby.
                <div><Link className="logo-blue-color" to="/contact ">Kontaktovať
                    ma môžete tu</Link></div>
            </div>
        </div>,
        en: <div><h3 className="mb-2 text-xl font-bold dark:text-white">Tomáš Marton</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text className="text-gray-700 dark:text-gray-100 font-bold">Specialization:</text>
                Financial controlling
            </p>
            <div>
                <div className="font-bold">Bio:</div>
                Tomáš is the financial controller of the Kernis team. Already during his studies, he started his
                career as a process specialist measuring the performance of internal company processes in the Košice
                branch of an international company, where
                later he worked as a company-wide financial controller. He currently works in Košice as a controller
                and data analyst specializing in analyzing trends and identifying anomalies in the field of pricing.
                <div><Link className="logo-blue-color" to="/contact ">You can contact me here</Link></div>
            </div>
        </div>,
    },
    'about.jevcik': {
        sk: <div><h3 className="mb-2 text-xl font-bold dark:text-white">Lukáš Jevčik</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text
                    className="text-gray-700 dark:text-gray-100 font-bold">Špecializácia:
                </text>
                Reporting
            </p>
            <div>
                <div className="font-bold">Bio:</div>
                Lukáš je technická podpora Kernis tímu s dlhoročnou praxou v príprave
                výkazov, prehľadov a prezentácií v tabuľkových ako aj „Business
                Intelligence“ aplikáciách.

                Po ukončení ekonomického štúdia na Middlesex University v Londýne a
                Technickej univerzite v Košiciach začal svoju kariéru na reportingovom
                oddelení košickej pobočky medzinárodnej spoločnosti. Tu neskôr
                ako procesný špecialista merania výkonu vnútro-firemných procesov prevzal aj
                vedenie tímu špecialistov a developerov. Aktuálne pôsobí ako reportingový
                developer a dátový analytik s bázou v Košiciach.
                <div><Link className="logo-blue-color" to="/contact ">Kontaktovať
                    ma môžete tu</Link></div>
            </div>
        </div>,
        en: <div><h3 className="mb-2 text-xl font-bold dark:text-white">Lukáš Jevčik</h3>
            <p className="text-gray-700 dark:text-gray-100 mb-3">
                <text className="text-gray-700 dark:text-gray-100 font-bold">Specialization:</text>
                Reporting
            </p>
            <div>
                <div className="font-bold">Bio:</div>
                Lukáš is the technical support of the Kernis team with many years of experience in the preparation
                of reports, overviews and presentations in spreadsheet and "Business Intelligence" applications.

                After completing economic studies at Middlesex University in London and Technical University in
                Košice, he started his career in the reporting department of the Košice branch of an international
                company. Here later
                as a process specialist in measuring the performance of internal company processes, he also took
                over the management of a team of specialists and developers. He currently works as a reporting
                developer and data analyst based in Košice.
                <div><Link className="logo-blue-color" to="/contact ">You can contact me here</Link></div>
            </div>
        </div>,
    },
    'gdpr': {
        sk: <div className="font-light dark:text-gray-100"><h3
            className="mb-4 text-xl font-bold logo-blue-color">INFORMÁCIE
            O OCHRANE OSOBNÝCH ÚDAJOV</h3> <p>Na tomto mieste by sme Vám radi vysvetlili akým spôsobom a za akými účelmi
            používame Vaše osobné údaje a aké máte práva a možnosti v tejto oblasti.</p> <br/> <p><strong
            className="font-bold">Kto je zodpovedný za Vaše osobné údaje?</strong></p> <p>Spoločnosť <strong
            className="font-bold">Kernis s. r. o.</strong>, so sídlom Želiarska 2, 040 13 Košice - mestská časť
            Ťahanovce, Slovenská republika, IČO: 56 042 680,je zodpovedným prevádzkovateľom aza určitých okolností aj
            sprostredkovateľom pre vybraných prevádzkovateľov pri spracúvaní Vašich osobných údajov.</p> <br/> <p>
            <strong className="font-bold">Na aké účely používame Vaše osobné údaje?</strong></p> <p>Vaše osobné údaje
            spracovávame na tieto účely (ďalej “ <strong className="font-bold">Povolené účely</strong>”):</p>
            <ul>
                <li className="ml-12"><strong className="font-bold">Poskytovanie služieb</strong><em>, </em>čím sa
                    rozumie spracúvanie Vašich osobných údajov pri poskytovaní služieb našou spoločnosťou;
                </li>
                <li className="ml-12"><strong className="font-bold">Evidencia a</strong><strong className="font-bold">spracúvanie
                    objednávok, zmlúv a</strong><strong className="font-bold">iných administratívnych
                    dokumentov</strong>, pri vykonávaní činnosti našou spoločnosťou;
                </li>
                <li className="ml-12"><strong className="font-bold">Uplatnenie práv a</strong><strong
                    className="font-bold">nárokov</strong>, čo zahŕňa spracúvanie Vašich osobných údajov zdôvodu
                    uplatnenia práv anárokov ato aj vsúdnom alebo administratívnom konaní atiež účely kontrol
                    vykonávaných orgánmi verejnej moci.
                </li>
            </ul>
            <p>Vaše osobné údaje spracúvame sohľadom na vyššie uvedené Povolené účely na uvedených právnych
                základoch:</p>
            <ol>
                <li className="ml-12"><strong className="font-bold">a) Plnenie zmluvy</strong>, ktorú uzatvárate snašou
                    spoločnosťou
                </li>
                <li className="ml-12"><strong className="font-bold">b) Plnenie našich zákonných povinností</strong>, ako
                    sú najmä naše účtovné adaňové povinnosti, ale aj sprístupnenie údajov orgánom verejnej moci vzákonom
                    stanovených prípadoch;
                </li>
                <li className="ml-12"><strong className="font-bold">c) Oprávnené záujmy</strong>, napr. vsúvislosti so
                    zlepšovanímnašich služieb apri niektorých marketingových činnostiach alebo aj viných prípadoch,
                    pričom tieto záujmy neprevyšujú tie Vaše alebo nezasahujú neprimeraným spôsobom do Vašich práv.
                </li>
                <li className="ml-12"><strong className="font-bold">d) Súhlas</strong>, ato predovšetkým vsúvislosti
                    sreklamnou a marketingovou činnosťou alebo vedením evidencie uchádzačov o zamestnanie. <strong
                        className="font-bold">Váš súhlas so spracovaním osobných údajov máte právo kedykoľvek
                        odvolať</strong>, stým, že toto odvolanie nemá spätnú platnosť, t.j. odvolanie súhlasu
                    neovplyvňuje platnosť spracovania údajov, ktoré bolo uskutočnené pred jeho odvolaním.
                </li>
            </ol>
            <br/> <p><strong className="font-bold">Aké osobné údaje zbierame?</strong></p> <p>Pokiaľ nie je inak
                dohodnuté, uchovávame len tie osobné údaje, ktoré sú potrebné vzhľadom na vybavenie Vašej objednávky,
                uzatvorenie zmluvy a dodanie objednaného tovaru, resp. vsúvislosti s vyššie spomenutými Povolenými
                účelmi. To zahŕňa informácie, ktoré nám sprostredkujete priamo, prostredníctvom formulára na našej
                internetovej stránke alebo ktoré nám poskytnete iným spôsobom.</p> <p>Jedná sa najmä nasledovné
                kategórie údajov:</p>
            <ul>
                <li className="ml-12"><em>osobné detaily, </em>ako meno a priezvisko, dátum narodenia, rodné číslo,
                    adresa trvalého pobytu, telefonický a emailový kontakt;
                </li>
                <li className="ml-12">osobné údaje finančnej povahy aúdaje orodinnom stave;</li>
                <li className="ml-12">údaje súvisiace s <em>prístupom a používaním našej internetovej stránky,</em> čo
                    predstavuje údaje zaznamenávajúce Vaše osobné preferencie, cookies;
                </li>
                <li className="ml-12">iné osobné údaje odvodené alebo vygenerované z vyššie uvedených Povolených
                    účelov.
                </li>
            </ul>
            <br/> <p><strong className="font-bold">Ako zbierame osobné údaje?</strong></p> <p>Vaše osobné údaje zbierame
                primárne priamo od Vás počas Vašej interakcie s nami prostredníctvom našich zmluvných partnerov alebo
                iným komunikačným spôsobom.</p> <br/> <p><strong className="font-bold">Ako chránime Vaše osobné
                údaje?</strong></p> <p>Na ochranu Vašich osobných údajov pred neoprávneným prístupom alebo zneužitiu
                využívame fyzické, elektronické a procedurálne bezpečnostné opatrenia, ktoré zodpovedajú technickému
                stavu a právnym požiadavkám na ochranu osobných údajov. Tieto bezpečnostné opatrenia zahrňujú
                implementáciu špecifických technológií a procedúr vytvorených na ochranu Vášho súkromia. Zaväzujeme sa
                po celý čas striktne dodržiavať zákony a nariadenia súvisiace s dôvernosťou a bezpečnosťou osobných
                údajov.</p> <br/> <p><strong className="font-bold">S</strong><strong className="font-bold">kým zdieľame
                Vaše osobné údaje?</strong></p> <p>Vaše osobné údaje môžeme zdieľať snašimi partnermi, ktorí nám
                pomáhajú sposkytovaním našich služieb alebo zabezpečujú administratívne aúčtovné služby.</p> <p>Vaše
                osobné údaje môžu byť tiež poskytnuté orgánom verejnej moci, vprípadoch, kedy to predpokladá príslušný
                právny predpis.</p> <br/> <p><strong className="font-bold">Kde spracúvame Vaše osobné údaje?</strong>
            </p> <p>Vaše osobné údaje nebudú spracúvané mimo Európskeho hospodárskeho priestoru (ďalej “<strong
                className="font-bold">tretie krajiny</strong>”) a naša spoločnosť nezamýšľa preniesť tieto údaje do
                tretej krajiny.</p> <br/> <p><strong className="font-bold">Vaše práva na ochranu osobných
                údajov</strong></p> <p>Za podmienok ustanovených príslušnými právnymi predpismi máte:</p>
            <ul>
                <li className="ml-12"><strong className="font-bold">právo na prístup </strong>k Vašim osobným údajom,
                    teda máte právo získať od nás potvrdenie, či oVás spracúvame osobné údaje. Vprípade, ak ich
                    spracúvame, môžete žiadať informácie o účeloch spracovania, kategórii osobných údajov, kategóriách
                    príjemcov, ktorým boli vaše údaje oznámené, plánovaných dobách uchovávania, pôvode vašich údajov, ak
                    neboli zhromaždené priamo od vás;
                </li>
                <li className="ml-12"><strong className="font-bold">právo na opravu</strong> Vašich osobných údajov,
                    vprípade ak sú spracúvané osobné údaje nesprávne, prípadne môžete požadovať ich doplnenie sohľadom
                    na účel ich spracúvania, ak sú tieto údaje neúplné;
                </li>
                <li className="ml-12"><strong className="font-bold">právo na vymazanie (právo na
                    zabudnutie)</strong> Vašich osobných údajov, ak:
                </li>
            </ul>
            <ol>
                <li className="ml-12">a) už nie sú potrebné na účely, na ktoré sa získavali alebo inak spracúvali,</li>
                <li className="ml-12">b) odvoláte svoj súhlas, na základe ktorého sa spracúvanie vykonáva a ak
                    neexistuje iný právny základ pre spracúvanie,
                </li>
                <li className="ml-12">c) namietnete na základe Vašej konkrétnej situácie spracúvanie Vašich osobných
                    údajov, spracúvaných na základe oprávneného záujmu a neprevažujú oprávnené dôvody na spracúvanie
                    alebo namietnete spracúvanie za účelom priameho marketingu,
                </li>
                <li className="ml-12">d) osobné údaje sa spracúvali nezákonne;</li>
            </ol>
            <ul>
                <li className="ml-12"><strong className="font-bold">právo na obmedzenie </strong>spracovania Vašich
                    osobných údajov, ak:
                </li>
            </ul>
            <ol>
                <li className="ml-12">a) namietate správnosť osobných údajov, a to počas obdobia umožňujúceho nám overiť
                    ich správnosť,
                </li>
                <li className="ml-12">b) spracúvanie je protizákonné, avšak namiesto vymazania údajov budete požadovať
                    obmedzenie ich spracúvania,
                </li>
                <li className="ml-12">c) už Vaše osobné údaje nepotrebujeme, ale tie sú potrebné pre Vaše účely týkajúce
                    sa uplatnenia právneho nároku,
                </li>
                <li className="ml-12">d)namietate ich spracúvanie ato až do overenia, či naše oprávnené záujmy prevažujú
                    nad Vašimi oprávnenými záujmami;
                </li>
            </ol>
            <ul>
                <li className="ml-12"><strong className="font-bold">právo na prenosnosť </strong>osobných údajov
                    vštruktúrovanom, bežne používanom astrojom čitateľnom formáte, ktoré sa Vás týkajú aktoré
                    uchovávame, kVami zvolenému inému prevádzkovateľovi;
                </li>
                <li className="ml-12"><strong className="font-bold">namietať voči spracovaniu</strong> Vašich osobných
                    údajov z dôvodov týkajúcich sa Vašej konkrétnej situácie, ktoré je vykonávané na základe nášho
                    oprávneného záujmu, vrátane práva namietať proti profilovaniu založenému na našom oprávnenom záujme.
                    Takisto máte právo namietať voči spracúvaniu Vašich osobných údajov, ak sa tieto spracúvajú na účely
                    priameho marketingu.
                </li>
            </ul>
            <br/> <p>Bližšie informácie týkajúce sa Vašich práv nájdete v článkoch 15 až 22 Všeobecného nariadenia o
                ochrane údajov Európskej únie.</p> <br/> <p>V prípade, že máte záujem podať jednu z vyššie uvedených
                žiadosti, kontaktujte nás na našich kontaktných údajoch uvedených vyššie, pričom uveďte svoje
                identifikačné údaje ako je meno a priezvisko. Za účelom ochrany Vašich osobných údajov a zabráneniu
                neoprávnenému prístupu k údajom môžeme požadovať aj ďalšie identifikačné údaje na overenie
                totožnosti.</p> <br/> <p>V prípade, že máte obavy ohľadom spracovania Vašich údajov, môžete nás
                kontaktovať na kontaktných údajoch uvedených nižšie. Vašu záležitosť prešetríme a ak nebudete spokojný s
                našou odpoveďou alebo máte zato, že sme Vaše osobné údaje nespracovávali v súlade s platnými
                zákonmi, <strong className="font-bold">máte právo</strong><strong className="font-bold">podať sťažnosť
                    na príslušný orgán</strong>, ktorým je na území Slovenskej republiky Úrad na ochranu osobných údajov
                Slovenskej republiky.</p> <br/> <p><strong className="font-bold">Ste povinný poskytnúť nám svoje osobné
                údaje?</strong></p> <p>Osobné údaje nám vzásade poskytujete dobrovoľne. Vurčitých prípadoch je
                poskytnutie týchto údajov nevyhnutné pre účely uzatvorenia zmluvy snašou spoločnosťou alebo na naplnenie
                vyššie uvedených povolených účelov. Ak nám v týchto prípadoch neposkytnete svoje osobné údaje, nebudeme
                schopní riadne plniť podmienky vyplývajúce zo zmluvy, vybaviť Váš podnet alebo poskytnúť Vám informácie
                onašich produktoch aslužbách.</p> <br/> <p><strong className="font-bold">Ako dlho uchovávame Vaše osobné
                údaje</strong></p> <p>Vaše osobné údaje spracúvame po nevyhnutnú dobu vzhľadom na Povolené účely.
                Konkrétna doba spracúvania osobných údajov je závislá od daného Povoleného účelu, právneho základu
                spracúvania apovahy spracovateľskej činnosti. Pre bližšie informácie odobe spracúvania konkrétnych
                osobných údajov nás môžete kontaktovať na nižšie uvedených kontaktných údajoch.</p> <p>V prípade, ak
                používame Vaše osobné údaje na základe Vášho súhlasu, uchovávame tieto údaje, kým nám príslušný súhlas
                neodvoláte alebo inak nezanikne dôvod ich spracúvania.</p> <p>V prípadoch spracúvania Vašich osobných
                údajov pre naše oprávnené záujmy, uchováme Vaše údaje, kým neodpadne dôvod ich spracúvania.</p>
            <p>Vosobitných prípadoch môže dôjsť kspracúvaniu Vašich osobných údajov aj mimo tu uvedených lehôt, napr.
                zdôvodu súdnych alebo administratívnych konaní alebo vprípadoch ustanovených príslušným právnym
                predpisom. V prípade záujmu o bližšie informácie nás prosím kontaktujte na nižšie uvedených kontaktných
                údajoch.</p> <br/> <p><strong className="font-bold">Aktualizácia informácie o</strong><strong
                className="font-bold">ochrane osobných údajov</strong></p> <p>Táto politika ochrany osobných údajov bola
                naposledy aktualizovaná vmáji 2024. Vyhradzujeme si právo na aktualizáciu a zmenu tejto informácie o
                ochrane osobných údajov s cieľom reflektovať a meniť spôsob, akým spracovávame Vaše osobné údaje, alebo
                zdôvodu zmeny právnej úpravy. Každá upravená verzia bude dostupná alebo zverejnená na Vám prístupných
                miestach.</p> <br/> <p><strong className="font-bold">Ako nás môžete kontaktovať?</strong></p> <p>V
                prípade, že budete mať akékoľvek otázky ohľadom Vašich práv alebo budete mať iné požiadavky súvisiace s
                Vašimi osobnými údajmi, kontaktujte nás prosím na uvedených kontaktných údajoch: hajduk@kernis.sk</p>
        </div>,
        en: <div className="font-light dark:text-gray-100">
            <h3
                className="mb-4 text-xl font-bold logo-blue-color">INFORMATION ON THE PROTECTION OF
                PERSONAL
                DATA</h3> <p>In this place, we would like to explain to you how and for what purposes we
            use
            your personal data data and what rights and options you have in this area.</p> <br/> <p>
            <strong className="font-bold">Who is responsible for your personal data?</strong></p>
            <p>Company <strong className="font-bold">Kernis s. r. o.</strong>, with registered office at
                Želiarska 2, 040 13 Košice - Ťahanovce district, Slovak Republic, IČO: 56 042 680, is
                the responsible operator and, under certain circumstances, an intermediary for selected
                operators in the processing of your personal data.</p> <br/><p><strong
            className="font-bold">For what purposes do we use your personal data?</strong></p> <p>We
            process your personal data for these purposes (hereinafter “ <strong
                className="font-bold">Permitted purposes</strong>”):</p>
            <ul>
                <li className="ml-12"><strong className="font-bold">Provision of
                    services </strong><em>, </em>which means the processing of your personal data during
                    the provision of services by our company;
                </li>
                <li className="ml-12"><strong className="font-bold">Recording and</strong><strong
                    className="font-bold">processing of orders, contracts and</strong><strong
                    className="font-bold">other administrative documents</strong>, when performing
                    activities by our company;
                </li>
                <li className="ml-12"><strong className="font-bold">Exercise of rights
                    and</strong><strong className="font-bold">claims</strong> , which includes the
                    processing of your personal data due to the exercise of rights and claims, including
                    judicial or administrative proceedings, as well as the purposes of checks carried
                    out by public authorities.
                </li>
            </ul>
            <p>We process your personal data in accordance with the above Permitted purposes on the
                stated legal bases:</p>
            <ol>
                <li className="ml-12"><strong className="font -bold">a) Fulfillment of the
                    contract</strong> that you conclude with the sister company
                </li>
                <li className="ml-12"><strong className="font-bold">b) Fulfillment of our legal
                    obligations </strong>, such as in particular our accounting tax obligations, but
                    also the disclosure of data to public authorities in cases established by law;
                </li>
                <li className="ml-12"><strong className="font-bold">c) Legitimate interests</strong>,
                    e.g. in connection with the improvement of our services and certain marketing
                    activities or in other cases, while these interests do not exceed yours or interfere
                    in an unreasonable way with your rights.
                </li>
                <li className="ml-12"><strong className="font-bold">d) Consent</strong>, especially in
                    connection with advertising and marketing activities or keeping records of job
                    applicants. <strong className="font-bold">You have the right to withdraw your
                        consent to the processing of personal data at any time</strong>, provided that
                    this withdrawal is not retroactive, i.e. withdrawal of consent does not affect the
                    validity of data processing that was carried out before its withdrawal.
                </li>
            </ol>
            <br/> <p><strong className="font-bold">What personal data do we collect?</strong></p>
            <p>Unless otherwise agreed, we keep only those personal data that are necessary in view of
                the processing of your order, the conclusion of the contract and the delivery of the
                ordered goods, or in connection with the Permitted Purposes mentioned above. This
                includes information that you provide to us directly, via a form on our website, or that
                you provide to us in another way.</p> <p>This mainly concerns the following categories
            of data:</p>
            <ul>
                <li className="ml- 12"><em>personal details, </em>such as first and last name, date of
                    birth, social security number, address of permanent residence, telephone and email
                    contact;
                </li>
                <li className="ml-12">personal data of a financial nature and family status data;</li>
                <li className="ml-12">data related to <em>access and use of our website,</em> which
                    represents data recording your personal preferences, cookies;
                </li>
                <li className="ml-12">other personal data derived or generated from the above Permitted
                    Purposes.
                </li>
            </ul>
            <br/> <p><strong className="font-bold">How do we collect personal data?</strong></p> <p>We
            collect your personal data primarily directly from You during your interaction with us
            through our contractual partners or in another communication method.</p> <br/> <p>
            <strong className="font-bold">How do we protect your personal data?</strong></p> <p>To
            protect your personal data from unauthorized access or misuse, we use physical,
            electronic and procedural security measures that correspond to the technical status and
            legal requirements for the protection of personal data. These security measures include
            the implementation of specific technologies and procedures designed to protect your
            privacy. We are committed to strictly complying with laws and regulations related to the
            confidentiality and security of personal data at all times.</p> <br/> <p><strong
            className="font-bold">S</strong><strong className="font-bold">who do we share your
            personal data with?</strong></p> <p>We may share your personal data with our
            partners,who help us by providing our services or provide administrative and accounting
            services.</p> <p>Your personal data may also be provided to public authorities, in cases
            where this is required by the relevant legal regulation.</p> <br/> <p><strong
            className="font-bold">Where do we process your personal data?</strong></p> <p>Your
            personal data will not be processed outside the European Economic Area (hereinafter
            “<strong className="font-bold ">third country</strong>") and our company does not intend
            to transfer this data to a third country.</p> <br/> <p><strong className="font-bold">Your
            rights to the protection of personal data</strong></p> <p>Under the conditions
            established by the relevant legal regulations, you have:</p>
            <ul>
                <li className="ml-12"><strong className="font-bold">the right to access your personal
                    data, i.e.</strong>you have the right to receive confirmation from us as to whether
                    we are processing personal data about you. If we process them, you can request
                    information about the purposes of the processing, the category of personal data, the
                    categories of recipients to whom your data has been communicated, the planned
                    storage periods, the origin of your data, if it was not collected directly from you;
                </li>
                <li className="ml-12"><strong className="font-bold">right to correction</strong> of your
                    personal data, if the processed personal data is incorrect, or you can request their
                    addition considering the purpose of their processing, if these data are incomplete;
                </li>
                <li className="ml-12"><strong className="font-bold">right to erasure (right to be
                    forgotten)</strong> of your personal data if:
                </li>
            </ul>
            <ol>
                <li className="ml-12">a) are no longer needed for the purposes for which they were
                    obtained or otherwise processed,
                </li>
                <li className="ml-12">b) you withdraw your consent, on the basis of which the processing
                    is carried out and if there is no other legal basis for the processing,
                </li>
                <li className="ml-12">c) you object, based on your specific situation, to the processing
                    of your personal data, processed on the basis of a legitimate interest and
                    legitimate reasons for processing do not prevail or you object to processing for the
                    purpose of direct marketing,
                </li>
                <li className="ml-12">d) personal data were processed illegally;</li>
            </ol>
            <ul>
                <li className="ml-12"><strong className="font-bold">the right to restrict </strong>the
                    processing of your personal data if:
                </li>
            </ul>
            <ol>
                <li className="ml-12">a) you object to the correctness of personal data, during the
                    period that allows us to verify their correctness,
                </li>
                <li className="ml-12">b) the processing is illegal, but instead of deleting the data,
                    you will request a limitation of their processing,
                </li>
                <li className="ml-12">c) we no longer need your personal data, but they are necessary
                    for your purposes regarding the exercise of a legal claim,
                </li>
                <li className="ml-12">d ) you object to their processing until it is verified whether
                    our legitimate interests prevail over your legitimate interests;
                </li>
            </ol>
            <ul>
                <li className="ml-12"><strong className="font-bold">the right to portability </strong>of
                    personal data in a structured, commonly used machine-readable format, which are
                    related to you, we store them to another operator chosen by you;
                </li>
                <li className="ml-12"><strong className="font-bold">object to the processing</strong> of
                    your personal data for reasons related to your specific situation, which is carried
                    out on the basis of our legitimate interest, including the right to object to
                    profiling based on our legitimate interest. You also have the right to object to the
                    processing of your personal data if it is processed for direct marketing purposes.
                </li>
            </ul>
            <br/> <p>More information regarding your rights can be found in Articles 15 to 22 of the
            General Data Protection Regulation of the European Union.</p> <br/> <p>In the event that
            If you are interested in making one of the above requests, please contact us at our
            contact details above, including your identifying information such as first and last
            name. In order to protect your personal data and prevent unauthorized access to data, we
            may also request additional identification data for identity verification.</p> <br/>
            <p>If you have concerns about the processing of your data, you can contact us at the contact
                details listed below. We will investigate your matter and if you are not satisfied with
                our answer or if you believe that we did not process your personal data in accordance
                with applicable laws, <strong className="font-bold">you have the right</strong><strong
                    className=" font-bold">file a complaint with the competent authority</strong>, which
                is the Personal Data Protection Office of the Slovak Republic in the territory of the
                Slovak Republic.</p> <br/> <p><strong className="font-bold ">Are you obliged to provide
            us with your personal data?</strong></p> <p>In principle, you provide us with personal
            data voluntarily. In certain cases, the provision of this data is necessary for the
            purposes of concluding a contract with the participating company or for the fulfillment
            of the above-mentioned permitted purposes. If you do not provide us with your personal
            data in these cases, we will not be able to properly fulfill the conditions arising from
            the contract, arrange yourdnet or provide you with information about our products and
            services.</p> <br/> <p><strong className="font-bold">How long do we keep your personal
            data</strong></p> <p>Your we process personal data for the necessary time in relation to
            the Permitted Purposes. The specific period of personal data processing depends on the
            given Permitted Purpose, the legal basis of the processing and the nature of the
            processing activity. For more information on how specific personal data is processed,
            you can contact us using the contact details below.</p> <p>If we use your personal data
            based on your consent, we store this data until you revoke the relevant consent or the
            reason otherwise ceases. their processing.</p> <p>In cases of processing your personal
            data for our legitimate interests, we will keep your data until the reason for their
            processing no longer exists.</p> <p>In certain cases, your personal data may also be
            processed outside of those listed here deadline, e.g. due to judicial or administrative
            proceedings or in cases established by the relevant legal regulation. If you are
            interested in more information, please contact us using the contact details below.</p>
            <br/> <p><strong className="font-bold">Update information about</strong><strong
            className="font-bold">privacy</strong></p> <p>This privacy policy was last updated in
            May 2024. We reserve the right to update and change this privacy policy to reflect and
            change the way we process your personal data, or the reason for a change in legislation.
            Each modified version will be available or published in places accessible to you.</p>
            <br/> <p><strong className="font-bold">How can you contact us?</strong></p> <p>In the event
            that you have any questions regarding your rights or have other requests related to your
            personal data, please contact us at the following contact details: hajduk@kernis.sk</p>
        </div>
    }
}